import Hdr from '../shared/Hdr'
import React from 'react'
import swal from 'sweetalert';
import { useState, useEffect } from 'react';
import { apiPath1, apiPath2 } from "../services/apiConfig";
//import {Link} from 'react-router-dom';
import TopBanner from '../components/TopBanner';
import { motion, AnimatePresence } from "framer-motion";

//import Modal from './Modal'; // Import your Modal component

//import ChangePw from '../components/ChangePw';

function StoreMaster() {

  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const user_id = localStorage.getItem('user-id');
  const usrName = localStorage.getItem('userName');
  const [updstorename, setUpdStoreName] = useState("");
  const [updlocation, setUpdLocation] = useState("");
  const [storeName, setStoreName] = useState("");
  const [updtype, setUpdType] = useState("");
  const [display, setDisplay] = useState(false);
  const [displayUpdate, setDisplayUpdate] = useState(false);
  const [data, setData] = useState([]);
  const [location, setLocation] = useState([]);
  const [storeID, setStoreID] = useState('')
  const [updlocationAddress, setUpdLocationAddress] = useState()
  const [storetype, setStoreType] = useState()
  const [address, setAddress] = useState('')
  const [storeTypeDesc, setStoreTypeDesc] = useState()

  const [consigneeName, setConsigneeName] = useState('')
  const [consigneeAddress, setConsigneeAddress] = useState('')
  const [updConsigneeName, setUpdConsigneeName] = useState()
  const [updConsigneeAddress, setUpdConsigneeAddress] = useState()

  const [selectedStoreTypeValue, setSelectedStoreTypeValue] = useState('0')
  const [selectedStoreValue, setSelectedStoreValue] = useState('')
  const [selectedAddressValue, setSelectedAddressValue] = useState('')
  const [selectedConsignee, setSelectedConsignee] = useState('')
  const [selectedConsigneeAddress, setSelectedConsigneeAddress] = useState('')
  const [selectedDept, setSelectedDept] = useState('0')

  const [deptdata, setDeptData] = useState([])
  const [department, setDept] = useState('')


  useEffect(() => {
    getData()
    getDepts()
  }, [])

  const containerVariants = {
    hidden: { x: "100vw" }, // Start off-screen to the right
    visible: { x: 0 },   // Slide into view
    exit: { x: "100vw" },  // Slide off-screen to the right when exiting
  };

  const transitionSettings = {
    duration: 0.5,
    type: "tween",
    ease: "easeInOut",
  };

    /* LIST OF ALL DEPTS */
    async function getDepts() {
  
      let result = await fetch(apiPath1 + "Departments",
        {
          method: 'GET',
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
          },
        });
      result = await result.json();
  
      if (result.status === true) { setDeptData(result.data) }
      else { setDeptData([]) }
    }

  /* DELETE DEPARTMENT */

  function ActivInactiveOperation(id) {

    if (usrRole === "staff") {
      swal("You are not authorized to delete!");
      return
    }

    swal({
      title: "Are you sure?",
      //text: "Once deleted, you will not be able to recover this data",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          ActivInactiveStore(id);
        }
        else {
          swal("Your record is safe!");
        }

      });

  }

  /* final CATAGORY deletion*/
  async function ActivInactiveStore(props) {

    let result = await fetch(apiPath1 + "toggleStoreActiveInactive/" + props,
      {
        method: 'PATCH',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    showSwal(result.status, result.msg)

    getData()

  }


  /* FIND CATAGORY RECORD ON THE BASIS OF CATAGORY ID*/

  async function updateOperation(id) {
    let result = await fetch(apiPath1 + "Store/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });

    result = await result.json();

    setUpdStoreName(result.data.store_name);
    setUpdType(result.data.store_type);
    setUpdLocationAddress(result.data.store_location_address);

    //  setUpdLocation(result.data.store_location)
    //  setStoreTypeDesc(result.data.store_type_description)

    setUpdConsigneeName(result.data.store_consignee_name)
    setUpdConsigneeAddress(result.data.store_consignee_address)

    setStoreID(id);
    openUpdateStore()

  }


  /* LIST OF ALL STORES (for initial screen) */

  async function getData() {

    let result = await fetch(apiPath1 + "AllStores",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      });
    result = await result.json();

    if (result.status === true) { setData(result.data) }
    else { setData([]) }
  }

  function openStore() {
    setDisplay(true)
  }

  function closeStore() {
    clearTransaction()
    setDisplay(false)
  }

  function openUpdateStore() {
    setDisplayUpdate(true)
  }

  function closeUpdateStore() {
    setDisplayUpdate(false)
  }

  function storeHandler(e) {
    e.preventDefault()
    setSelectedStoreValue(e.target.value)
    setStoreName(e.target.value)
  }

  function storeTypeHandler(e) {
    e.preventDefault()
    setSelectedStoreTypeValue(e.target.value)
    setStoreType(e.target.value)
  }

  function updateStoreHandler(e) {
    e.preventDefault()
    setUpdStoreName(e.target.value)
  }

  function updlocationHandler(e) {
    e.preventDefault()
    setUpdLocation(e.target.value)
  }

  function updlocationAddressHandler(e) {
    e.preventDefault()
    setUpdLocationAddress(e.target.value)
  }

  function updateConsigneeName(e) {
    e.preventDefault()
    setUpdConsigneeName(e.target.value)
  }

  function updateConsigneeAddress(e) {
    e.preventDefault()
    setUpdConsigneeAddress(e.target.value)
  }

  function addressHandler(e) {
    e.preventDefault()
    setSelectedAddressValue(e.target.value)
    setAddress(e.target.value)
  }


  function consigneeAddressHandler(e) {
    e.preventDefault()
    setSelectedConsigneeAddress(e.target.value)
    setConsigneeAddress(e.target.value)
  }


  function consigneeHandler(e) {
    e.preventDefault()
    setSelectedConsignee(e.target.value)
    setConsigneeName(e.target.value)
  }


  function deptHandler(e) {
    e.preventDefault()
    setSelectedDept(e.target.value)
    setDept(e.target.value)
  }


  /* ADDING NEW STORE*/

  async function addStore() {
    //  alert(storeName+", "+consigneeName+','+consigneeAddress+','+storetype+', '+address)
    let result = await fetch(apiPath1 + "StoreAdd", {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "store_name": storeName,
        "store_type": storetype,
        "store_consignee_name": consigneeName,
        "store_consignee_address": consigneeAddress,
        "store_location_address": address,
        "dept_id": department
      })
    });
    result = await result.json();

    showSwal(result.status, result.msg)

    getData()
    //   setStoreName('')
  }

  /* MODIFY A STORE,    */

  async function updateStore() {
    // alert(storeID+', '+updstorename+', '+', '+updtype+', '+updlocationAddress+', '+updConsigneeName+', '+updConsigneeAddress)
    let result = await fetch(apiPath1 + "StoreUpdate", {
      method: 'PATCH',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": storeID,
        "store_name": updstorename,
        "store_type": updtype,
        "store_location_address": updlocationAddress,
        "store_consignee_name": updConsigneeName,
        "store_consignee_address": updConsigneeAddress
      })
    });

    result = await result.json();

    showSwal(result.status, result.msg)

    closeUpdateStore();
    getData()

  }

  function clearTransaction() {
    setSelectedStoreTypeValue('0');
    setSelectedStoreValue('');
    setSelectedAddressValue('');
    setSelectedConsignee('');
    setSelectedConsigneeAddress('');
  }

  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success !",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }


{/*  
  const [dataFromChild, setDataFromChild] = useState(false);

  const handleChildData = (data) => {
    setDataFromChild(data);
//    setIsModalOpen(data)
  };


  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
*/}



  return (

    <div style={{ 'width': '100%', 'height': '100vh' }}>
      <Hdr />
      <TopBanner name={'Store Master'} />
  {/*     <TopBanner name={'Store Master'} onDataSend={handleChildData} />
      <p>Data from Child: {dataFromChild.toString()}</p>
     <p>Data from Child: {dataFromChild ? <ModalX /> : <p>Status: Inactive</p>}</p>  */}

      <div className="row p16 " style={{ 'height': '95%' }}>
        <div className=" c12-l-12 cont__content-parent p4" style={{ 'height': '100%' }}>
          {/* CTA SECTION */}
          <div className="row mb16 ">
            <div className="c12-l-4">
            </div>
            <div className="c12-l-6"></div>
            <div className="c12-l-2 align-bottom-right">
              <button onClick={openStore} type="button" name="button"
                className="btn large gradient round">Add New Store</button>
            </div>
          </div>

          {/* DATA TABLE SECTION */}
          <div className="c12-l-12 cont__content p4" style={{ 'height': '88%' }}>
            <table style={{ 'display': 'block' }}>
              <thead className='thead-blue'>
                <tr>
                  <th className="th-border left" width="5%">Id</th>
                  <th className="th-border left" width="15%">Store Name</th>
                  <th className="th-border left" width="10%">Type</th>
                  <th className="th-border left" width="20%">Location Address</th>
                  <th className="th-border left" width="15%">Department</th>
                  <th className="th-border left" width="30%">Consignee Name</th>
                  <th className="th-border left" width="30%">Consignee Address</th>
                  <th className="th-border" width="10%">Edit</th>
                  <th className="th-border" width="5%">Active</th>
                </tr>
              </thead>
              <tbody >
                {
                  data.map((item, index) =>
                    <tr className="tr-two-color-grey" key={index}>
                      <td className="" style={{ 'verticalAlign': 'top', 'fontSize': '10px' }}>{item.id}</td>
                      <td className="" style={{ 'verticalAlign': 'top' }}>{item.store_name}</td>
                      <td className="" style={{ 'verticalAlign': 'top' }}>{item.store_type_description}</td>
                      <td className="" style={{ 'verticalAlign': 'top', 'fontSize': '10px' }}>{item.store_location_address}</td>
                      <td className="" style={{ 'verticalAlign': 'top', 'fontSize': '10px' }}>{item.dept_name}</td>
                      <td className="" style={{ 'verticalAlign': 'top', 'fontSize': '10px' }}>{item.store_consignee_name}</td>
                      <td className="" style={{ 'verticalAlign': 'top', 'fontSize': '10px' }}>{item.store_consignee_address}</td>
                      <td onClick={() => { updateOperation(item.id) }} className="center"><img src={require('../asset/icons/adm_edit.png')} alt="" /></td>
                      <td onClick={() => { ActivInactiveOperation(item.id) }} className="center">{(item.is_active === 1) ? <img src={require('../asset/icons/adm_ok.png')} alt="" /> : <img src={require('../asset/icons/adm_close_old.png')} alt="" />}</td>

                    </tr>
                  )
                }
              </tbody>
            </table>

          </div>


        {/*Trying Modal
        {
          (dataFromChild === true ?
            (
              <ChangePw data = {dataFromChild} />  
            )
            : <div>No data</div>)
        } 
{/*
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <h2>Modal Title</h2>
        <p>This is the content of your modal.</p>
      </Modal>
*/}
        {/* SCREEN FROM ADDING NEW STORE */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
          {display && (
          <motion.div
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="newStore" className="cont__lineitem">

            <form className="" action="" method="">
              <div className="row box gradient corner-round-tr">
                <div className="c12-l-5">
                  <h3 className='txt-subtlewhite'>Add Store</h3>
                </div>
                <div className="c12-l-6"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeStore}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32 px16">
                <div className="c12-l-12">

                  <p>Store Name</p>
                  <input type="text" value={selectedStoreValue} className="box small"
                    placeholder="Name of the Store" onChange={storeHandler} />

                  <p>Store/Delivery Address</p>
                  <textarea type="text" value={selectedAddressValue} className="box small"
                    placeholder="Address" onChange={addressHandler} />

                  <p>Consignee Name</p>
                  <input type="text" value={selectedConsignee} className="box small"
                    placeholder="Consignee Name" onChange={consigneeHandler} />

                  <p>Consignee Address</p>
                  <textarea type="text" value={selectedConsigneeAddress} className="box small"
                    placeholder="Consignee Assress" onChange={consigneeAddressHandler} />

                  <p style={{ 'fontSize': '0.75rem' }}>Select Department</p>
                  <select className="small" value={selectedDept} onChange={deptHandler}>
                    <option value="0" >Select Department</option>
                    {
                      deptdata.map((item, index) =>
                        <option key={item.id} value={item.id}>{item.dept_name}</option>
                      )
                    }
                  </select>

                  <p style={{ 'fontSize': '0.75rem' }}>Store Type</p>
                  <select className="small" value={selectedStoreTypeValue} onChange={storeTypeHandler}>
                    <option value="0">Select Store</option>
                    <option value="warehouse">warehouse</option>
                    <option value="site">site</option>
                    <option value="repair">Repair Shop</option>
                  </select>

                  <br /><br />
                  <button onClick={addStore} type="button" name="button"
                    className="btn gradient round">Add Store</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>

        {/* SCREEN FROM MODIFYING STORE */}

        <AnimatePresence> {/* Wrap with AnimatePresence */}
        {displayUpdate && (

          <motion.div
            key="sliding-container" // Crucial for AnimatePresence to work
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit" // Specify the exit animation
            transition={transitionSettings}
            id="updateStore" className="cont__lineitem">

            <form className="" action="" method="">
              <div className="row box gradient corner-round-tr">
                <div className="c12-l-7">
                  <h3 className='txt-subtlewhite'>Update Store</h3>
                </div>
                <div className="c12-l-4"></div>
                <div className="c12-l-1 align-right">
                  <p onClick={closeUpdateStore}><img src={require('../asset/icons/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32 px16">
                <div className="c12-l-12">
                  <p>Name</p>
                  <input type="text" className="box small"
                    placeholder="Name of the Store" onChange={updateStoreHandler}
                    value={updstorename} />

                  <p>Store/Delivery Address</p>
                  <textarea type="text" className="box small"
                    placeholder="Address" onChange={updlocationAddressHandler}
                    value={updlocationAddress} />

                  <p>Consignee Name</p>
                  <input type="text" className="box small"
                    placeholder="Name of the Store" onChange={updateConsigneeName}
                    value={updConsigneeName} />

                  <p>Consignee Address</p>
                  <textarea type="text" className="box small"
                    placeholder="Address" onChange={updateConsigneeAddress}
                    value={updConsigneeAddress} />

                  <p style={{ 'fontSize': '0.75rem' }}>Store Type</p>
                  <select className="small" value={updtype} onChange={(e) => setUpdType(e.target.value)}>
                    <option value="warehouse">warehouse</option>
                    <option value="site">site</option>
                    <option value="repair">Repair Shop</option>
                    setUpdType
                  </select>

                  <br />
                  <button className="btn gradient round large" type="button" onClick={() => { updateStore() }}>Update Store</button>
                </div>
              </div>
            </form>
          </motion.div>
          )}
        </AnimatePresence>

        </div>
      </div>
    </div>
  );
}

export default StoreMaster;
